module.exports = __webpack_public_path__ + "media/1.36f3c19b.mp3";